import ValaszTableService from 'app/admin/valasz/service/ValaszTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'valaszTable',
	text: 'Hozzáférés',
	textKey: 'question',
	service: ValaszTableService,
	icon: 'person',
	editFormState: item => `/valasz/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh', 'new'],
    //backLink: () => {
    //    if (data.directory === 0) {
    //        return '/kerdes';
    //    }
    //    return `/kerdes/${data.current.parentDirectory != null ? data.current.parentDirectory.id : '0'}/${data.storage}`;
    //},
	filterFields: [
		{
			propertyName: 'name',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
        {
			key: 'betujel',
			text: 'Betűjel',
			textKey: 'betujel',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
        {
			key: 'helyes',
			text: 'Helyes',
			textKey: 'helyes',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'name',
			text: 'Szöveg',
			textKey: 'name',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function ValaszTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('valaszTable', reducer('valaszTable'))(ValaszTable);
